import NumericField, { getNumericFieldRegisterProps } from './NumericField';

const registerProps = getNumericFieldRegisterProps('Invalid annual income value');

const AnnualIncomeField = props => (
    <NumericField
        leftAdornment="$"
        rightAdornment="/year"
        labelText="Annual income"
        helpText="Include pre-tax income from full-time or part-time work, self-employment, tips, comissions, overtime, bonuses, etc."
        registerProps={registerProps}
        {...props}
    />
);

export default AnnualIncomeField;
